import { Icon } from '@eventbrite/eds-icon';
import {
    HeartChunky,
    HouseChunky,
    MagnifyingGlassChunky,
    TicketChunky,
    UserChunky,
} from '@eventbrite/eds-iconography';
import { logEvent } from '@eventbrite/statsig';
import { Nullable } from '@eventbrite/ts-utils';
import loadable from '@loadable/component';
import React, { useState } from 'react';
import './MobileNavFooter.scss';

const LazySearchTakeover = loadable.lib(
    () => import('@eventbrite/search-takeover'),
);

const STATSIG_EVENT_CLICK_HOME = 'All - Footer Nav - Click - Home';
const STATSIG_EVENT_CLICK_SEARCH = 'All - Footer Nav - Click - Search';
const STATSIG_EVENT_CLICK_TICKETS = 'All - Footer Nav - Click - Tickets';
const STATSIG_EVENT_CLICK_PROFILE = 'All - Footer Nav - Click - Profile';
const STATSIG_EVENT_CLICK_LIKED = 'All - Footer Nav - Click - Liked Events';
export interface MobileNavFooterProps {
    isAuthenticated?: boolean;
    userId?: string;
    activeNavIcon?: string;
}

export const MobileNavFooter: React.FunctionComponent<MobileNavFooterProps> = ({
    isAuthenticated,
    userId,
    activeNavIcon,
}) => {
    const [showSearchTakeover, setShowSearchTakeover] =
        useState<Nullable<boolean>>(null);

    const handleHomeClick = () => {
        logEvent(STATSIG_EVENT_CLICK_HOME);
    };

    const handleTicketsClick = () => {
        logEvent(STATSIG_EVENT_CLICK_TICKETS);
    };

    const handleSearchClick = () => {
        logEvent(STATSIG_EVENT_CLICK_SEARCH);
        setShowSearchTakeover(true);
    };

    const handleProfileClick = () => {
        logEvent(STATSIG_EVENT_CLICK_PROFILE);
    };

    const handleLikedClick = () => {
        logEvent(STATSIG_EVENT_CLICK_LIKED);
    };

    return (
        <div data-testid="mobile-nav-footer">
            <nav className="nav-footer-mobile eds-bg-color--background">
                <ul className="nav-footer-mobile__list">
                    <li>
                        <a
                            href="/"
                            data-testid="home-icon"
                            onClick={handleHomeClick}
                        >
                            <Icon type={<HouseChunky />} />
                        </a>
                    </li>
                    {isAuthenticated && (
                        <li>
                            <a
                                href={`/u/${userId}/`}
                                data-testid="ticket-icon"
                                onClick={handleTicketsClick}
                            >
                                <Icon type={<TicketChunky />} />
                            </a>
                        </li>
                    )}
                    <li>
                        <div
                            role="button"
                            className={`${
                                activeNavIcon === 'search' ? 'active' : ''
                            } search-icon`}
                            data-testid="search-icon"
                            onClick={handleSearchClick}
                        >
                            <Icon type={<MagnifyingGlassChunky />} />
                        </div>
                    </li>
                    {isAuthenticated && (
                        <li>
                            <a
                                href={`/u/${userId}/favorites/events`}
                                data-testid="liked-icon"
                                onClick={handleLikedClick}
                            >
                                <Icon type={<HeartChunky />} />
                            </a>
                        </li>
                    )}
                    <li>
                        <a
                            href={
                                isAuthenticated
                                    ? '/account-settings/'
                                    : '/signin/'
                            }
                            data-testid="profile-icon"
                            onClick={handleProfileClick}
                        >
                            <Icon type={<UserChunky />} />
                        </a>
                    </li>
                </ul>
            </nav>
            {showSearchTakeover !== null ? (
                <LazySearchTakeover>
                    {({ SearchTakeover }: { SearchTakeover: any }) => (
                        <SearchTakeover
                            domNodeId="root"
                            onClose={() => setShowSearchTakeover(false)}
                            id="search-takeover"
                            isVisible={showSearchTakeover}
                        />
                    )}
                </LazySearchTakeover>
            ) : null}
        </div>
    );
};
